import React from 'react';
import { 
  Compass, Star, Zap, Target, Lightbulb, 
  ShieldCheck, Rocket, BrainCircuit, Home, PieChart as PieChartIcon 
} from 'lucide-react';
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';

const CAREER_GROUPS = {
  'A': { name: "Doğa ve Tarım", color: "#10b981", desc: "Ziraat, Orman, Çevre vb." },
  'B': { name: "Mekanik ve Teknoloji", color: "#f59e0b", desc: "Mimarlık, Makine, Tasarım vb." },
  'C': { name: "Liderlik ve Yönetim", color: "#3b82f6", desc: "Hukuk, İşletme, Yöneticilik vb." },
  'D': { name: "Sanat ve Medya", color: "#ec4899", desc: "Sinema, Müzik, Resim, Medya vb." },
  'E': { name: "Edebiyat ve İletişim", color: "#8b5cf6", desc: "Edebiyat, Gazetecilik, PDR vb." },
  'F': { name: "Sosyal Bilimler", color: "#14b8a6", desc: "Psikoloji, Sosyoloji, Tarih vb." },
  'G': { name: "Uluslararası İlişkiler", color: "#06b6d4", desc: "Uluslararası İlişkiler, Diplomasi vb." },
  'H': { name: "Tıp ve Sağlık", color: "#ef4444", desc: "Tıp, Diş Hekimliği, Eczacılık vb." },
  'I': { name: "Finans ve Analiz", color: "#6366f1", desc: "İktisat, Ekonomi, Finans vb." },
  'İ': { name: "Yazılım ve Bilişim", color: "#84cc16", desc: "Bilgisayar, Yazılım, Bilişim vb." }
};

export const KariyerPusulasiReportUI = ({ data, meta }) => {
  if (!data || !data.scores) return <div className="p-10 text-center font-bold">Veri bulunamadı.</div>;

  const chartData = Object.keys(data.scores)
    .filter(key => CAREER_GROUPS[key])
    .map(key => ({
      name: CAREER_GROUPS[key].name,
      score: data.scores[key],
      fill: CAREER_GROUPS[key].color,
      desc: CAREER_GROUPS[key].desc
    }))
    .sort((a, b) => b.score - a.score);

  const top1 = chartData[0] || { name: "Belirsiz", score: 0, fill: "#cbd5e1", desc: "-" };
  const top2 = chartData[1] || { name: "Belirsiz", score: 0, fill: "#cbd5e1", desc: "-" };
  const top3 = chartData[2] || { name: "Belirsiz", score: 0, fill: "#cbd5e1", desc: "-" };

  return (
    // ZIRH 1: Dikey boşlukları print modunda hafifçe daralttık (print:space-y-4)
    <div className="space-y-5 print:space-y-4 font-sans flex flex-col bg-white relative z-10 print:m-0 print:p-0">
      
      {/* ÜST BAŞLIK - KOMPAKT */}
      <div className="bg-slate-900 text-white p-4 print:p-3 rounded-2xl flex justify-between items-center shadow-sm shrink-0">
        <div className="flex items-center gap-4 print:gap-3">
          <div className="h-12 w-12 rounded-xl flex items-center justify-center shadow-inner bg-blue-600">
            <Compass className="h-6 w-6 text-white"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-black leading-none mb-1">Kariyer Pusulası Yönelim Profili</h2>
            <span className="text-[10px] print:text-[9px] text-slate-400 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • NO: {meta?.studentNo || "-"} • {meta?.studentName || "İsimsiz Kayıt"}
            </span>
          </div>
        </div>
      </div>

      {/* ÜST PANEL: GRAFİK VE PODYUM */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-5 print:gap-4 shrink-0 avoid-break">
        
        {/* SOL: PASTA (DONUT) GRAFİĞİ VE LİSTE */}
        {/* ZIRH 2: Yükseklik 320px'den 290px'e çekilerek A4 için alan yaratıldı */}
        <div className="bg-white p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col h-[320px] print:h-[290px] overflow-hidden">
          <h3 className="font-black text-slate-800 text-[11px] print:text-[10px] uppercase tracking-widest mb-3 flex items-center border-b pb-2 shrink-0">
            <PieChartIcon className="h-4 w-4 mr-2 text-blue-600"/> Eğilim Dağılımı
          </h3>
          
          <div className="flex-1 flex items-center justify-between min-w-0 gap-3 mt-1">
            {/* SOL YARI: İÇİ BOŞ PASTA GRAFİĞİ */}
            <div className="w-[50%] h-full relative flex items-center justify-center">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    innerRadius="60%"
                    outerRadius="90%"
                    paddingAngle={4}
                    dataKey="score"
                    stroke="none"
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.fill} />
                    ))}
                  </Pie>
                  <Tooltip 
                    contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)', fontSize: '11px', padding: '6px 10px' }} 
                    itemStyle={{ color: '#334155', fontWeight: 'bold' }}
                  />
                </PieChart>
              </ResponsiveContainer>
              <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                <span className="text-[8px] font-bold text-slate-400 uppercase tracking-widest">ZİRVE</span>
                <span className="text-[11px] font-black text-slate-800 text-center px-2 leading-none mt-1">{top1.name}</span>
              </div>
            </div>

            {/* SAĞ YARI: EN YÜKSEK 5 YÖNELİM (LEJANT LİSTESİ) */}
            {/* MÜDAHALE: justify-center yerine justify-start vererek listeyi yukarı çektik. Boşlukları (gap ve p) milimetrik daralttık. */}
            <div className="w-[50%] flex flex-col gap-2 print:gap-1.5 justify-start pt-1">
              {chartData.slice(0, 5).map((item, idx) => (
                <div key={idx} className="flex items-center gap-2.5 bg-slate-50 p-2 print:p-1.5 rounded-lg border border-slate-100">
                  <div className="h-3 w-3 print:h-2.5 print:w-2.5 rounded-full shrink-0" style={{ backgroundColor: item.fill }}></div>
                  <div className="flex-1 min-w-0">
                    <p className="text-[11px] print:text-[9.5px] font-bold text-slate-700 truncate leading-none mb-0.5">{item.name}</p>
                    <p className="text-[9px] print:text-[7.5px] text-slate-400 leading-none">{item.score} Puan</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* SAĞ: ZİRVEDEKİ 3 YÖNELİM */}
        <div className="flex flex-col gap-4 print:gap-3">
          <div className="bg-blue-50/40 p-5 print:p-4 rounded-2xl border border-blue-100 shadow-sm flex-1 flex flex-col justify-center relative overflow-hidden">
            <div className="absolute top-0 right-0 w-20 h-20 opacity-10 rounded-bl-full bg-blue-600"></div>
            <span className="text-[10px] print:text-[9px] font-black uppercase tracking-widest text-blue-600 mb-1.5 flex items-center">
              <Star className="h-4 w-4 mr-1.5 fill-current"/> 1. Baskın Eğilim
            </span>
            <h3 className="text-2xl print:text-xl font-black leading-tight text-slate-800 mb-1">{top1.name}</h3>
            <p className="text-[11px] print:text-[10px] text-slate-500 font-medium leading-relaxed">{top1.desc}</p>
          </div>

          <div className="grid grid-cols-2 gap-4 print:gap-3">
            <div className="bg-slate-50 p-4 print:p-3 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center">
                <span className="text-[9px] print:text-[8px] font-black uppercase tracking-widest text-slate-400 mb-1.5 block">2. Yönelim</span>
                <h4 className="text-sm print:text-xs font-black text-slate-700 leading-tight">{top2.name}</h4>
            </div>
            <div className="bg-slate-50 p-4 print:p-3 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center">
                <span className="text-[9px] print:text-[8px] font-black uppercase tracking-widest text-slate-400 mb-1.5 block">3. Yönelim</span>
                <h4 className="text-sm print:text-xs font-black text-slate-700 leading-tight">{top3.name}</h4>
            </div>
          </div>
          
          <div className="bg-emerald-50/50 p-4 print:p-3 rounded-2xl border border-emerald-100 flex items-center gap-3">
             <ShieldCheck className="h-8 w-8 text-emerald-500 shrink-0"/>
             <p className="text-[11px] print:text-[10px] text-emerald-800 font-medium leading-snug">
               Öğrencinin içsel motivasyonu <strong>{top1.name}</strong> alanında en yüksek seviyededir.
             </p>
          </div>
        </div>
      </div>

      {/* ALT PANEL: STRATEJİK BİLGİLENDİRME KARTLARI */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-5 print:gap-4 shrink-0 avoid-break">
        
        {[
          { icon: Zap, title: "Kariyer Dinamiği", text: "Öğrencinin yönelimleri, rutin işlerden ziyade problem çözme ve sonuç odaklılık üzerine kuruludur. Seçilen alanlarda somut başarılar elde etme isteği baskındır.", bg: "bg-indigo-50", color: "text-indigo-600" },
          { icon: Home, title: "İdeal Çalışma Ortamı", text: "Hiyerarşinin esnek olduğu, yaratıcılığın teşvik edildiği ve bireysel sorumluluk alabileceği dinamik ortamlar bu profil için en yüksek verimliliği sağlar.", bg: "bg-amber-50", color: "text-amber-600" },
          { icon: Target, title: "Kritik Yetkinlik Odağı", text: "Mesleki başarısını desteklemek için stratejik zaman yönetimi ve disiplinlerarası iş birliği becerilerini geliştirmesi, kariyer basamaklarını daha hızlı tırmanmasını sağlar.", bg: "bg-rose-50", color: "text-rose-600" },
          { icon: BrainCircuit, title: "Öğrenme Stratejisi", text: "Öğrenci, teorik bilgileri uygulama (vaka analizi, proje) ile birleştirdiğinde kalıcı öğrenme gerçekleştirir. Laboratuvar veya saha çalışmaları motivasyonunu artıracaktır.", bg: "bg-emerald-50", color: "text-emerald-600" }
        ].map((card, idx) => (
          <div key={idx} className={`p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm bg-white h-[140px] print:h-[130px] overflow-hidden flex flex-col`}>
             <div className="flex items-center gap-3 mb-2.5">
               <div className={`h-8 w-8 rounded-lg flex items-center justify-center ${card.bg}`}>
                 <card.icon className={`h-4 w-4 ${card.color}`}/>
               </div>
               <h4 className="font-bold text-slate-800 text-[11px] print:text-[10px] uppercase tracking-wider">{card.title}</h4>
             </div>
             <p className="text-[11px] print:text-[10px] text-slate-600 leading-relaxed text-justify line-clamp-3">
               {card.text}
             </p>
          </div>
        ))}

        {/* GENİŞ KART */}
        {/* ZIRH 3: SENİN FARK ETTİĞİN YER! print:col-span-2 eklendi ve yüksekliği PDF'e göre ayarlandı. */}
        <div className="bg-slate-50 p-5 print:p-4 rounded-2xl border border-slate-200 shadow-sm col-span-1 md:col-span-2 print:col-span-2 flex items-center gap-4 h-[85px] print:h-[75px]">
           <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
             <Rocket className="h-5 w-5 text-blue-600"/>
           </div>
           <div>
             <h4 className="font-bold text-slate-800 text-[10px] uppercase tracking-[0.2em] mb-1">Gelecek Projeksiyonu</h4>
             <p className="text-[11px] print:text-[10px] text-slate-700 leading-relaxed">
               Bu yönelimlere sahip bireyler genellikle "yenilikçi liderler" olarak tanımlanır. Seçilen meslek grubunda vizyon belirleyen pozisyonlara adaydırlar.
             </p>
           </div>
        </div>
      </div>

      {/* ETİK UYARI */}
      <div className="p-3 print:p-2.5 bg-slate-50 rounded-xl border border-slate-200 shrink-0 mt-auto">
        <p className="text-[10px] print:text-[9px] text-slate-500 text-center leading-relaxed">
          <strong>Önemli Not:</strong> Bu rapor öğrencinin anlık kariyer eğilimlerini yansıtan bir rehberlik materyalidir. Kesin meslek seçimi için akademik başarı ve diğer faktörler birlikte değerlendirilmelidir.
        </p>
      </div>

    </div>
  );
};